export {Collapsible, type CollapsibleProps} from "./collapsible";
